module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAUBAMAAABohZD3AAAAD1BMVEUAlUN+ukfcJB/rgTT73kqD5DwiAAAAOklEQVR42l3JQQ2AMADAwOFhCk4CFsC/pm0fSNpfc+PrenfP//P8HRYWFhYWFhYWFhYWFhYWFhYWtgAmbyaZJknktwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/cg.png
// module id = 254
// module chunks = 0